var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Folder icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---View-Project---Desktop",
    transform: "translate(-404.000000, -2456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(380.000000, 2209.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D9D9D7",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 865,
    height: 312,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Foler-circle",
    transform: "translate(24.055556, 247.158576)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.31509255 L0,20.9955872 C0,21.4295051 0.390697759,21.8243601 0.820075758,21.8243601 L23.2354798,21.8243601 C23.6648578,21.8243601 24.0555556,21.4295051 24.0555556,20.9955872 L24.0555556,7.18269954 C24.0555556,6.74878167 23.6648578,6.35398187 23.2354798,6.35392662 L12.9759904,6.35392662 L10.2082347,2.79710947 C10.0550965,2.60383963 9.81255634,2.48631951 9.56755051,2.48631951 L0.820075758,2.48631951 C0.378639912,2.4962649 0.00899076389,2.96584764 0,3.31509255 L0,3.31509255 Z M1.9135101,4.42012357 L8.92132218,4.42012357 L11.6775296,7.98661028 C11.8287944,8.18404189 12.0714007,8.30574972 12.3175159,8.30766573 L22.1420455,8.30766573 L22.1420455,19.890556 L1.9135101,19.890556 L1.9135101,4.42012357 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a91c1ff3ce1584653463dc087f4458d7.svg";
export { ForwardRef as ReactComponent };